<template>
    <div class="floor-item" @click="handleCargoClick" v-loading="loading">
        <div>
            <div class="goods-name">{{ cargo.sku_name }}</div>
            <div class="price-wrap">
                <div class="price">￥{{ cargo.price }}</div>
                <div class="dis-price">￥{{ cargo.market_price }}</div>
            </div>
        </div>

        <div class="img-wrap">
            <el-image fit="cover" :src="$img(cargo.sku_image, { size: 'mid' })" @error="cargo.sku_image = defaultGoodsImage" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { goodsSkuDetail } from "@/api/goods/goods"

    export default {
        name: "cargo_item",
        props: {
            cargo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                cargoDetail: {},
                loading: false
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            handleCargoClick() {
                if (this.cargo && this.cargo.sku_id) {
                    this.$router.pushToTab(`/sku-${this.cargo.sku_id}`)
                }
            }
        },
        watch: {}
    }
</script>

<style lang="scss" scoped>
    .floor-item {
        padding: 11px;
        border: 1px solid #f1f1f1;
        margin-right: 12px;
        margin-top: 5px;
        cursor: pointer;
        background: #fff;
        &:nth-child(-n + 5) {
            margin-top: 5px;
        }
        &:hover {
            border: 1px solid $base-color;
        }
        &:nth-of-type(5n) {
            margin-right: inherit;
        }
        .img-wrap {
            width: 208px;
            /* height: 208px; */
        }
        .goods-name {
            width: 112px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 5px;
        }
        .price-wrap {
            display: flex;
            align-items: flex-end;
            margin-left: -4px;
            .price {
                font-size: $ns-font-size-lg;
                color: $base-color;
            }
            .dis-price {
                color: #838383;
                text-decoration: line-through;
                margin-left: 8px;
                margin-bottom: 2px;
            }
        }
    }
</style>
